import { Routes } from '@angular/router';

import { FullComponent } from './layouts/full/full.component';

import { StartComponent } from './pages/start/start.component';
import { LoginComponent } from './pages/login/login.component';
import { HomeComponent } from './pages/home/home.component';
import { UsuariosComponent } from './pages/mantenedores/usuarios/usuarios.component';
import { CallbackComponent } from './components/callback/callback.component';
import { AuthGuardService } from '@services/varios/authGuard.service';
import { EmptyComponent } from './pages/empty/empty.component';
import { CargaMasivaComponent } from './pages/mantenedores/usuarios/carga-masiva/carga-masiva.component';
import { LogsComponent } from './pages/mantenedores/log/logs.component';
import { PerfilesComponent } from './pages/mantenedores/perfiles/perfiles.component';
import { PerfilesUsuarioComponent } from './pages/mantenedores/usuarios/perfiles-usuario/perfiles-usuario.component';
import { SistemaComponent } from './pages/mantenedores/sistema/sistema.component';

export const AppRoutes: Routes = [
  { path: '', component: StartComponent },
  { path: 'login', component: LoginComponent, },
  { path: 'login/:id', component: LoginComponent },   
  { path: 'auth/callback', component: CallbackComponent  },
  {
    path: '',
    component: FullComponent,
    children: [
      {
        path: 'home',
        component: HomeComponent
      }
    ]
  }, 
  {
    path: '',
    component: FullComponent,
    children: [
      {
        path: 'empty',
        component: EmptyComponent
      }
    ]
  }, 
  {
    path: '',
    component: FullComponent,
    children: [
      {
        path: 'mantenedores/usuarios',
        canActivate: [AuthGuardService],
        component: UsuariosComponent
      }
    ]
  },
  {
    path: '',
    component: FullComponent,
    children: [
      {
        path: 'mantenedores/usuarios/carga-masiva',
        canActivate: [AuthGuardService],
        component: CargaMasivaComponent
      }
    ]
  },
  {
    path: '',
    component: FullComponent,
    children: [
      {
        path: 'mantenedores/logs',
        canActivate: [AuthGuardService],
        component: LogsComponent
      }
    ]
  },
  {
    path: '',
    component: FullComponent,
    children: [
      {
        path: 'mantenedores/perfiles',
        canActivate: [AuthGuardService],
        component: PerfilesComponent
      }
    ]
  },
  {
    path: '',
    component: FullComponent,
    children: [
      {
        path: 'mantenedores/perfiles-usuarios',
        canActivate: [AuthGuardService],
        component: PerfilesUsuarioComponent
      }
    ]
  },
  {
    path: '',
    component: FullComponent,
    children: [
      {
        path: 'mantenedores/sistema',
        canActivate: [AuthGuardService],
        component: SistemaComponent
      }
    ]
  },
  {
    path: 'design',
    component: FullComponent,
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: '',
        loadChildren:
          () => import('./material-component/material.module').then(m => m.MaterialComponentsModule)
      },
      {
        path: 'pages',
        loadChildren:
          () => import('./pages/pages.module').then(m => m.PagesComponentsModule)
      }
    ]
  }
];
